"use client";

import { motion } from "framer-motion";
import Image from "next/image";

import { galleryImages } from "@/components/home/data";

export type LifeStripTranslations = {
  lifeAt: string;
  youthAlive: string;
};

const defaultTranslations: LifeStripTranslations = {
  lifeAt: "Life at",
  youthAlive: "Youth Alive",
};

type LifeAtYafStripProps = {
  translations?: LifeStripTranslations;
};

export const LifeAtYafStrip = ({
  translations = defaultTranslations,
}: LifeAtYafStripProps) => {
  const duplicatedImages = [...galleryImages, ...galleryImages];

  return (
    <section
      id="life"
      className="py-24 bg-zinc-50 dark:bg-black overflow-hidden border-y border-zinc-200 dark:border-white/5 transition-colors duration-500 relative"
    >
      <div className="px-6 mb-16 text-center relative z-10">
        <h2 className="font-serif text-5xl text-black dark:text-white italic">
          {translations.lifeAt} <span className="text-brand-red dark:text-brand-gold">{translations.youthAlive}</span>
        </h2>
      </div>

      <div className="flex overflow-hidden">
        <motion.div
          animate={{
            x: ["0%", "-50%"],
          }}
          transition={{
            duration: 40,
            repeat: Infinity,
            ease: "linear",
            repeatType: "loop",
          }}
          className="flex flex-nowrap w-max"
          style={{ willChange: "transform" }}
        >
          {duplicatedImages.map((img, i) => (
            <div key={i} className="shrink-0 px-3">
              <div className="w-[300px] md:w-[450px] aspect-[4/3] rounded-[2rem] overflow-hidden relative group shadow-lg">
                <Image
                  src={img.src}
                  alt={img.alt}
                  fill
                  className="object-cover group-hover:scale-110 transition-transform duration-700"
                  sizes="(max-width: 768px) 300px, 450px"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-8">
                  <span className="text-white font-serif italic text-2xl">{img.alt}</span>
                </div>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
